var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSRtlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5589_497)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2664 3.7334V14.9307H78.1744V3.7334H80.2664Z",
    fill: "#49D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2264 12.0496L69.3753 14.9336H67.2L70.8491 3.73633H73.367L76.9999 14.9336H74.713L73.8592 12.0552H70.2264V12.0496ZM73.4299 10.4036L72.0975 5.87598H72.005L70.6726 10.4036H73.4299Z",
    fill: "#49D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5V60.375V74.1333C0 79.5825 4.41747 84 9.86668 84H71.8846C75.0978 84 78.1794 82.8938 80.4515 80.9246C82.7236 78.9555 84 76.2848 84 73.5V18.6667H77.9423H66.7556C64.9392 18.6667 63.4667 17.1942 63.4667 15.3778V0H12.1154C8.90218 0 5.82059 1.10625 3.54852 3.07538C1.27644 5.04451 0 7.71523 0 10.5Z",
    fill: "#49D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.996 29.724C35.0133 29.724 36.668 29.9847 37.96 30.506C39.2747 31.0047 40.2493 31.764 40.884 32.784C41.5187 33.804 41.836 35.0847 41.836 36.626C41.836 37.918 41.598 38.9947 41.122 39.856C40.646 40.7173 40.034 41.4087 39.286 41.93C38.5607 42.4287 37.79 42.8253 36.974 43.12L43.638 54H40.068L34.186 43.97H29.358V54H26.298V29.724H32.996ZM32.826 32.376H29.358V41.386H32.996C34.3107 41.386 35.3873 41.216 36.226 40.876C37.0647 40.5133 37.6767 39.992 38.062 39.312C38.47 38.632 38.674 37.782 38.674 36.762C38.674 35.6967 38.4587 34.8467 38.028 34.212C37.62 33.5773 36.9853 33.1127 36.124 32.818C35.2627 32.5233 34.1633 32.376 32.826 32.376ZM47.4484 54V29.724H50.5084V51.28H61.1164V54H47.4484Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5589_497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSRtlLogo);
export default __webpack_public_path__ + "static/media/S_RTL_Logo.a9eb18d83485231d4c73375fc448edd9.svg";
export { ForwardRef as ReactComponent };